/* eslint-disable  */
import { slugCreator, useStore, useTimeoutdelay } from '../../core/useStore';
import { staticDocsMenu } from '../static';
import { SubMenuFromConfig, SvbMenuContentFromSpec } from './components/SubMenuFromConfig';
import { menuSpecResults } from '../../pages/SVBApiDocComponent/apiDocHelpers/helpers/Helpers';

// use the below function to sort please don't use reverse or any
function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

// Build dynamic menu from static docsMenu and browse-response
const sideMenu = async (browse = []) => {
  // validation
  while (browse?.length === 0) {
    useStore.setState({ apiSideMenuResolved: true });
    return false;
  }
  // check if state has menu already
  let menu = useStore.getState().apiSideMenu;

  if (menu?.length > 0 && useStore.getState().apiSideMenuResolved === true) {
    return menu;
  }
  // Empty obj to store items
  let items = [];
  let itemsBySolType = [];
  let docsMenu = staticDocsMenu;
  let apisVersionControl = [];
  const highestVersionItems = {};
  //get highest version of each item?.name or api name and create an array to hold the version
  await browse?.forEach((item) => {
    if (!highestVersionItems[item?.name] || highestVersionItems[item?.name] < item?.version) {
      highestVersionItems[item?.name] = item?.version;
    }
  });
  //update Items with version check/status value to be 1 for highest version item obj and 0 for rest
  const versionFullCheck = await browse?.map((item) => ({
    ...item,
    versionCheck: item?.version === highestVersionItems[item?.name] ? 1 : 0,
  }));
  // Initialize i so that uniques id's are built per menu-item
  await versionFullCheck?.forEach(async (item, index) => {
    // Start submenus and more from configs
    // check if the menu exist before
    // We check if there's a config file within the menu
    //  if there's a config file then there should be a page for it
    //  if not then we created it as holder
    // Make sure solution_type already exists in itemsBySolType object
    if (!itemsBySolType[item?.solution_type]) {
      // If not, create a new group with the key and set the value to empty array
      itemsBySolType[item?.solution_type] = {
        id: index + 111,
        name: item?.solution_type,
        description: item?.solution_type,
        link: `/apis/${slugCreator(item?.solution_type)}`,
        // content: item?.content || '',
        // path: `/apis/${slugCreator(item?.solution_type)}`,
        subMenu: [],
      };
    }

    // Build and push each sub-menu item to appropriate solution_type group
    const link = `/apis/${slugCreator(item?.solution_type)}/${slugCreator(item?.name)}/${
      item?.version
    }`;

    await SubMenuFromConfig(item, link, index).then(async (x) => {
      // apisVersionControl create a list of version by name of api
      if (!apisVersionControl[item?.api_display_name]) {
        apisVersionControl[item?.api_display_name] = [];
        apisVersionControl[item?.api_display_name].push({
          id: slugCreator(
            `${item?.solution_type}-${item?.name}-${item?.api_display_name}-${item?.version}-${
              index + 222
            }`,
          ),
          api_status: item?.api_status || '',
          status: item?.versionCheck,
          original: item?.api_display_name,
          version: item?.version || '',
        });
      } else {
        apisVersionControl[item?.api_display_name].push({
          id: slugCreator(
            `${item?.solution_type}-${item?.name}-${item?.api_display_name}-${item?.version}-${
              index + 222
            }`,
          ),
          api_status: item?.api_status || '',
          status: item?.versionCheck,
          original: item?.api_display_name,
          version: item?.version || '',
        });
      }
      useStore.setState({ apisVersionControl: apisVersionControl });
      if (typeof x.body === 'object' && x.body[0]) {
        itemsBySolType[item?.solution_type]['subMenu'][index + 222] = await {
          id: slugCreator(
            `${item?.solution_type}-${item?.name}-${item?.api_display_name}-${item?.version}-${
              index + 222
            }`,
          ),
          api_status: item?.api_status || '',
          status: item?.versionCheck,
          original: item?.api_display_name,
          name: item?.api_display_name,
          link: `/apis/${slugCreator(item?.solution_type)}/${item?.name}/${item?.version}`,
          techReference: x?.techReference || '',
          // type: "docs",
          version: item?.version || '',
          // path: `${link}/${slugCreator(item?.name)}`,
          filePath: `/apis/${item?.name}/${item?.version}`,
          apiMachineName: item?.name,
          subMenu: [],
        };

        //  content submenu
        // create menu level version to hide
        x.body?.map(async (itemX) => {
          return await itemsBySolType[item?.solution_type]['subMenu'][index + 222].subMenu.push({
            id: slugCreator(`${itemX.title}-${itemX.version}-${itemX.title}`),
            api_status: item?.api_status || '',
            status: item?.versionCheck,
            original: item?.api_display_name,
            name: itemX.title,
            type: 'docs',
            content: itemX.content || '',
            description: itemX.description || item?.description || item?.api_display_name,
            version: item?.version || '',
            techReference: x.techReference || '',
            postman: x.postman || '',
            link: `${link}/${slugCreator(itemX.title)}`,
            path: `${link}/${slugCreator(itemX.title)}`,
            apiMachineName: item?.name,
            filePath: `/apis/${item?.name}/${item?.version}`,
          });
        });
        //  Sub menu from Spec
        if (x.techReference && x.techReference !== '') {
          // Create Spec reader sub menu
          await SvbMenuContentFromSpec(`apis/${item?.name}/${item?.version}`, x.techReference)
            .then((z) => {
              return menuSpecResults(`${link}/${slugCreator(item?.name)}`, item, z, index, x);
            })
            .then(async (dataNow) => {
              const data = dataNow.sort(dynamicSort('version'));

              await data.map((y, xds) => {
                return itemsBySolType[item?.solution_type]['subMenu'][index + 222].subMenu.push({
                  id: slugCreator(
                    `${item?.solution_type}-${item?.api_display_name}-subMenu-${y.sourcePath}-${
                      y.version
                    }-${index + 222 + xds}`,
                  ),
                  api_status: item?.api_status || '',
                  status: item?.versionCheck,
                  original: item?.api_display_name,
                  name: y.tag,
                  specPath: y.sourcePath,
                  type: 'api-contract-parent',
                  content: y.content || [],
                  description: y.description || item?.description || item?.api_display_name,
                  version: item?.version || '',
                  techReference: x.techReference || '',
                  postman: x.postman || '',
                  link: `${link}/${slugCreator(item?.name)}?path=${y.sourcePath}`,
                  path: `${link}/${slugCreator(item?.name)}?path=${y.sourcePath}`,
                  apiMachineName: item?.name,
                  filePath: `/apis/${item?.name}/${item?.version}`,
                  subMenu: y.value,
                });
              });
            })
            .catch((err) => console.log(err));
        }
      } else if (typeof x.body === 'object') {
        itemsBySolType[item?.solution_type]['subMenu'][index + 222] = await {
          id: slugCreator(
            `${item?.solution_type}-${item?.api_display_name}-subMenu-${item?.title}-${
              item?.version
            }-${index + 3333}`,
          ),
          api_status: item?.api_status || '',
          status: item?.versionCheck,
          original: item?.api_display_name,
          name: item?.api_display_name,
          techReference: item?.techReference || '',
          postman: item?.postman || '',
          type: 'api-contract',
          version: item?.version || '',
          link: `${link}/${slugCreator(item?.title)}`,
          path: `${link}/${slugCreator(item?.title)}`,
          subMenu: [
            {
              id: slugCreator(
                `${item?.solution_type}-${item?.api_display_name}-subMenu-${
                  x.body?.title
                }-subMenu-${item?.version}-${index + 9999}`,
              ),
              api_status: item?.api_status || '',
              status: item?.versionCheck,
              original: item?.api_display_name,
              name: x.body?.title,
              type: 'docs',
              content: x.body?.content || '',
              description: x.body?.description || item?.description || item?.api_display_name,
              version: item?.version || '',
              techReference: x.techReference || '',
              postman: x.postman || '',
              link: `${link}/${slugCreator(x.body?.title)}`,
              path: `${link}/${slugCreator(x.body?.title)}`,
              apiMachineName: item?.name,
              filePath: `/apis/${item?.name}/${item?.version}`,
            },
          ],
        };
        //  Sub menu from Spec
        if (x.techReference && x.techReference !== '') {
          // Create Spec reader sub menu
          await SvbMenuContentFromSpec(`apis/${item?.name}/${item?.version}`, x.techReference)
            .then((z) => {
              return menuSpecResults(`${link}/${slugCreator(item?.name)}`, item, z, index, x);
            })
            .then(async (data) => {
              await data.map((y) => {
                return itemsBySolType[item?.solution_type]['subMenu'][index + 222].subMenu.push({
                  id: slugCreator(
                    `${item?.solution_type}-${item?.api_display_name}-subMenu-${y.key}-subMenu-${
                      y.tag
                    }-${index + 777}`,
                  ),
                  api_status: item?.api_status || '',
                  status: item?.versionCheck,
                  original: item?.api_display_name,
                  name: y.tag,
                  type: 'api-contract',
                  spec: y.content || [],
                  description: y.description || item?.description || item?.api_display_name,
                  version: item?.version || '',
                  techReference: x.techReference || '',
                  postman: x.postman || '',
                  link: `${link}/${slugCreator(item?.name)}/${slugCreator(y.key)}`,
                  path: `${link}/${slugCreator(item?.name)}/${slugCreator(y.key)}`,
                  apiMachineName: item?.name,
                  filePath: `/apis/${item?.name}/${item?.version}`,
                  subMenu: y.value,
                });
              });
            })
            .catch((err) => console.log(err));
        }
      } else {
        itemsBySolType[item?.solution_type]['subMenu'][index + 222] = await {
          id: slugCreator(
            `${item?.solution_type}-${item?.api_display_name}-subMenu-${item?.key}-${
              item?.tag
            }-subMenu-${item?.name}-${index + 777}`,
          ),
          api_status: item?.api_status || '',
          status: item?.versionCheck,
          original: item?.api_display_name,
          name: item?.api_display_name,
          type: 'api-contract',
          version: item?.version || '',
          link: `${link}/${slugCreator(item?.name)}`,
          path: `${link}/${slugCreator(item?.name)}`,
          apiMachineName: item?.name,
          filePath: `/apis/${item?.name}/${item?.version}`,
        };
      }
    });
  });

  // Required to make the code synchronous
  // await wait(3500)

  // To push solutionType items in the sequence sent by browse
  let i = 0;
  Object.keys(itemsBySolType).forEach(function (key) {
    items.push(itemsBySolType[key]);
    docsMenu.splice(4 + i, 0, itemsBySolType[key]);
    i = i + 1;
  });
  // Do the filter for submenus here for now
  /**
   * @todo: move it to helpers if needed
   * Filter to remove duplicate menu items
   */
  const docMenuItems = [...docsMenu].reverse();
  docsMenu = [...new Map(docMenuItems.map((item) => [item['name'], item])).values()].reverse();
  // useStore.setState({ apiSideMenu: [] });
  // useStore.setState({ apiSideMenu: docsMenu });
  // await useStore.setState({ defaultApiSideMenu: [] });
  // await useStore.setState({ defaultApiSideMenu: docsMenu });
  await useTimeoutdelay(100);
  useStore.setState({ apiSideMenuResolved: true });
  return docsMenu;
};
/**
 * getMenuItem
 * @param {string} path
 * @param {integer} id
 */
// const getMenuItem = (path, menu) => {
//   // check if state has menu already
//   console.log("pathfromgetMenuItem", path)
//   console.log("menufromgetMenu", menu)
//   let item = [];
//   menu.forEach((x) => {
//     if (x.path === path || x.link === path) {
//       item?.push(x);
//     } else {
//       if (x.subMenu) {
//         let submenu = x.subMenu;
//         return submenu.forEach((y) => {
//           if (y.path === path || y.link === path) {
//             item?.push(y);
//           } else {
//             if (y.subMenu) {
//               let submenu = y.subMenu;
//               return submenu.forEach((z) => {
//                 if (z.path === path || z.link === path) {
//                   item?.push(z);
//                 } else {
//                   if (z.subMenu) {
//                     let submenu = z.subMenu;
//                     return submenu.forEach((f) => {
//                       if (f.path === path || f.link === path) {
//                         item?.push(f);
//                       } else {
//                         if (f.subMenu) {
//                           let submenu = f.subMenu;
//                           return submenu.forEach((g) => {
//                             if (g.path === path || g.link === path) {
//                               item?.push(g);
//                             } else {
//                               if (g.subMenu) {
//                                 let submenu = g.subMenu;
//                                 return submenu.forEach((l) => {
//                                   if (l.path === path || l.link === path) {
//                                     item?.push(l);
//                                   } else {
//                                     if (l.subMenu) {
//                                       let submenu = l.subMenu;
//                                       return submenu.forEach((h) => {
//                                         if (h.path === path || h.link === path) {
//                                           item?.push(h);
//                                         }
//                                       });
//                                     }
//                                   }
//                                 });
//                               }
//                             }
//                           });
//                         }
//                       }
//                     });
//                   }
//                 }
//               });
//             }
//           }
//         });
//       }
//     }
//   });
//   console.log("Returnedfrommenuitem", item[0])
//   return item[0];
// };

// rewrite of getMenuItem
async function getMenuItem(path, menu, objFromRoute) {
  let useStoreMenu;

  if (!menu.length) {
    // useStoreMenu = useStore((state) => state.apiSideMenu);
    useStoreMenu = useStore.getState().apiSideMenu;
  } else {
    useStoreMenu = menu;
  }

  if (objFromRoute && Object.keys(objFromRoute).length > 0) {
    //handles page render while reloading api pages
    //only in the condition when routes object are passed as parameter
    //for eg {folderOne,folderTwo, folderThree } = {'commercial-banking-apis', 'virtual-cards', '2.0'}
    const { folderOne, folderTwo, folderThree } = objFromRoute;
    const recursivelySearchInSubMenus = async (subMenuArr) => {
      //func to recursively look for path in subMenus
      for (let obj of subMenuArr) {
        if (obj.path === path || obj.link === path) {
          return obj;
        }

        if (obj.subMenu && Array.isArray(obj.subMenu)) {
          const foundItem = await recursivelySearchInSubMenus(obj.subMenu);
          if (foundItem) return foundItem;
        }
      }
    };
    // const encodedPathTofind = encodeURIComponent(path);
    return new Promise(async (resolve, reject) => {
      let foundItem = null;
      //find the parent object by the parentkey
      const parentObject = useStoreMenu.find((obj) => slugCreator(obj.name) === folderOne);
      //If there is no subMenu found or parentObject is not available return null promise
      if (!parentObject || !parentObject.subMenu || !Array.isArray(parentObject.subMenu)) {
        return resolve(null);
      }
      await useTimeoutdelay(300);
      //get clean array of objects
      const filteredParentMenuItems = Object.values(parentObject.subMenu);
      //find objects with apiMachiname and version matcheing with respective requested route params folderTwo and folderThree
      const matching1stLevelSubmenuItem = filteredParentMenuItems.filter(
        (subMenuObj) =>
          subMenuObj.apiMachineName === folderTwo && subMenuObj.version === folderThree,
      );
      // once filtered out the object or objects search for requested path within it or submenus recursively until it is found
      for (let obj of matching1stLevelSubmenuItem) {
        //only use required object to look for matching path rather than unnecessary looping in other objects
        if (obj.path === path || obj.link === path) {
          foundItem = obj;
          break;
        }
        //if not found check if object has submenu and recursively search for path
        if (obj.subMenu && Array.isArray(obj.subMenu)) {
          foundItem = await recursivelySearchInSubMenus(obj.subMenu);
          if (foundItem) break;
        }
      }

      resolve(foundItem);
    });
  } else {
    //@todo old logic when route object is not passed to func (getMenuItem)
    // remove once another logic is tested out in other places where this func(getMenuItem) is used
    for (let i = 0; i < useStoreMenu.length; i++) {
      const item = useStoreMenu[i];
      // return item if path matches
      if (item?.path === path || item?.link === path) {
        const mainItem = new Promise((resolve) => setTimeout(() => resolve(item)));
        return mainItem;
      }
      // recursively get into subMenu and re-call func
      if (item?.subMenu && item?.subMenu.length > 0) {
        const subMenuItem = getMenuItem(path, item?.subMenu);
        if (subMenuItem) {
          return subMenuItem;
        }
      }
    }
    return null;
  }
}

export { sideMenu, getMenuItem };
